<div class="popup">
  <div class="popup-header">
    <h1 class="title" matDialogTitle>Agregar tarjeta</h1>
    <button mat-icon-button class="close-button" (click)="dialogRef.close(false)">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="popup-body">
  <div class="popup-columns" [class.popup-columns--two]="isCreate">
  <form [formGroup]="itemForm" (ngSubmit)="submit()" class="form_edit_card" [id]="formId">
    <div class="edit_card grid">
      <div class="items">
        <label for="nameHolderCreditCard">Nombre del Tarjetahabiente*</label>
        <div class="input-container">
          <input
            matInput
            id="nameHolderCreditCard"
            name="nameHolderCreditCard"
            [formControl]="itemForm.controls['nameHolderCreditCard']"
            type="text"
            placeholder="Nombre">
          </div>
          @if (itemForm.controls['nameHolderCreditCard'].hasError('required') && itemForm.controls['nameHolderCreditCard'].touched) {
            <small
              class="form-error-msg"> Nombre es requerido
            </small>
          }
        </div>

        <div class="items">
          <label for="numberCreditCard">Número de Tarjeta*</label>
          <div class="input-container">
            <input
              matInput
              id="numberCreditCard"
              name="numberCreditCard"
              [formControl]="itemForm.controls['numberCreditCard']"
              type="tel"
              placeholder="xxxx-xxxx-xxxx-xxxx"
              maxlength="19"
              pattern="[0-9\-]*"
              (keypress)="onlyNumberKey($event)"
              (input)="formatCreditCardNumber()"
              />
            </div>
            @if (itemForm.controls['numberCreditCard'].hasError('required') && itemForm.controls['numberCreditCard'].touched) {
              <small
                class="form-error-msg"> Número es requerido
              </small>
            }
            @if (itemForm.controls['numberCreditCard'].hasError('invalidLength') && itemForm.controls['numberCreditCard'].touched) {
              <small
                class="form-error-msg"> El número de tarjeta debe tener 15 o 16 dígitos
              </small>
            }
            @if (itemForm.controls['numberCreditCard'].hasError('invalidCardNumber') && itemForm.controls['numberCreditCard'].touched) {
              <small
                class="form-error-msg"> Número de tarjeta inválido
              </small>
            }
          </div>

          <div class="items">
            <label for="expMonthCreditCard">Mes de Expiración*</label>
            <div class="select-wrapper">
              <select
                id="expMonthCreditCard"
                name="expMonthCreditCard"
                [formControl]="itemForm.controls['expMonthCreditCard']">
                <option value="" selected disabled>Selecciona un mes</option>
                @for (month of months; track month) {
                  <option [value]="month.value">{{ month.label }}</option>
                }
              </select>
            </div>
            @if (itemForm.controls['expMonthCreditCard'].hasError('required') && itemForm.controls['expMonthCreditCard'].touched) {
              <small
                class="form-error-msg"> Mes es requerido
              </small>
            }
          </div>

          <div class="items">
            <label for="expYearCreditCard">Año de Expiración*</label>
            <div class="select-wrapper">
              <select
                id="expYearCreditCard"
                name="expYearCreditCard"
                [formControl]="itemForm.controls['expYearCreditCard']">
                <option value="" selected disabled>Selecciona un año</option>
                @for (year of years; track year) {
                  <option [value]="year.value">{{ year.label }}</option>
                }
              </select>
            </div>
            @if (itemForm.controls['expYearCreditCard'].hasError('required') && itemForm.controls['expYearCreditCard'].touched) {
              <small
                class="form-error-msg"> Año es requerido
              </small>
            }
          </div>
        </div>

      </form>

    @if (isCreate) {
      <section class="address-section">
        <h2 class="address-title">{{ 'customerCards.billingAddressTitle' | translate }}</h2>
        @if (addressesLoaded) {
          <app-billing-address-picker
            [customerId]="data.customerId"
            [addresses]="addresses"
            [initialSelectedId]="selectedAddressId"
            [autoOpenForm]="true"
            (selectionChange)="onAddressSelection($event)"
            (addressCreated)="onAddressCreated($event)"
            (busyChange)="onPickerBusy($event)"></app-billing-address-picker>
        }
        @if (addressMissing && addressesLoaded) {
          <small class="form-error-msg address-required" role="alert">{{ 'customerCards.addressRequired' | translate }}</small>
        }
      </section>
    }
  </div>
  </div>

  <div class="button-container">
    <button type="submit" [attr.form]="formId" mat-raised-button color="primary" [disabled]="!canSubmit" class="save">
      Agregar tarjeta
    </button>
  </div>
    </div>
